module.exports = __webpack_public_path__ + "img/R6__1265.376b3dc1.jpeg";